<template>
  <h2 class="text-xl text-gray-800 text-medium">Nici un rezultat gasit</h2>
</template>

<script>
export default {};
</script>

<style></style>
